import { render } from "./InformeFinanceroView.vue?vue&type=template&id=1e5774f4"
import script from "./InformeFinanceroView.vue?vue&type=script&lang=js"
export * from "./InformeFinanceroView.vue?vue&type=script&lang=js"

import exportComponent from "/home/xavi/Escriptori/rocabo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__